import React, { useContext, useState, useEffect, useRef } from "react";
import { jwtDecode } from "jwt-decode";
import { useParams, useNavigate } from "react-router-dom";
import { TransactionContext } from "../Context/TransactionContext";
import "../styleSheets/transaction.css";
import "../styleSheets/transactionDetail.css";
import instamart from "../images/instamart.jpg";
import restaurant from "../images/restaurant.jpg";
import { UserContext } from "../Context/UserContext";

const TransactionDetail = (props) => {
  const { transactions, getTransactions, editTransaction, deleteTransaction } =
    useContext(TransactionContext);
  const { getUserProfile, userDetails } = useContext(UserContext);

  const navigate = useNavigate();

  //TESTING>......
  // useEffect(() => {
  //   getUserProfile();
  // }, []);

  const token = localStorage.getItem("token");
  let myId = "";
  if (token) {
    const decoded = jwtDecode(token);
    myId = decoded.user.id;
  }

  const [users, setUsers] = useState([]);
  const [editFinalUsers, setEditFinalUsers] = useState([]);

  const ref = useRef(null);
  const refClose = useRef(null);

  const [newItem, setNewItem] = useState({
    newId: "",
    newDate: "",
    newType: "",
    newName: "",
    newAmount: "",
    newPaidBy: "",
    newtNote: "",
    newDiscount: "",
    newUsers: [],
    newSplitMode: "equal",
    newSplits: {},
  });

  const { id } = useParams();

  useEffect(() => {
    if (transactions.length === 0) {
      getTransactions();
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("token")) {
      getTransactions();

      fetch(`${process.env.REACT_APP_API_URL}/api/users/friends`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((res) => res.json())
        .then((data) => setUsers(data.friends || []))
        .catch((err) => console.error("User fetch error:", err));
    }
  }, []);

  useEffect(() => {
    if (newItem.newSplitMode !== "manual") return;

    const users = [...new Set([myId, ...newItem.newUsers])];

    const total =
      Number(newItem.newAmount || 0) - Number(newItem.newDiscount || 0);

    if (!users.length || !total) return;

    const perHead = Math.floor(total / users.length);

    const newSplits = {};
    users.forEach((u) => {
      newSplits[u] = perHead;
    });

    setNewItem((prev) => ({
      ...prev,
      newSplits,
    }));
  }, [newItem.newSplitMode, newItem.newAmount, newItem.newUsers]);

  const getFinalUsers = () => {
    return editFinalUsers.length ? editFinalUsers : [];
  };

  const currentTransaction = transactions.find((e) => {
    return String(e._id) === String(id);
  });

  if (!currentTransaction) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div
          className="spinner-border spinner-border-sm me-2"
          role="status"
        ></div>
      </div>
    );
  }

  let tLogo = null;

  if (currentTransaction.fType === "instamart") {
    tLogo = instamart;
  } else if (currentTransaction.fType === "swiggyfood") {
    tLogo =
      "https://1000logos.net/wp-content/uploads/2021/05/Swiggy-emblem.png";
  } else if (currentTransaction.fType === "restaurant") {
    tLogo = restaurant;
  } else if (currentTransaction.fType === "creditcard") {
    tLogo =
      "https://img.freepik.com/free-vector/realistic-credit-card-design_23-2149126091.jpg";
  } else {
    tLogo =
      "https://clubrunner.blob.core.windows.net/00000000127/Images/misc.png";
  }

  function formatToIST(isoString) {
    const date = new Date(isoString);

    const options = {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour12: false,
    };

    const parts = new Intl.DateTimeFormat("en-GB", options).formatToParts(date);

    const map = {};
    parts.forEach((p) => (map[p.type] = p.value));

    return `${map.day}-${map.month}-${map.year}  ${map.hour}:${map.minute}`;
  }

  //EDITING PART STARTS HERE...................................

  const onManualSplitChange = (uid, value) => {
    const total = Number(newItem.newAmount);
    const users = [...new Set([myId, ...newItem.newUsers])];

    const entered = Number(value) || 0;

    const remainingUsers = users.filter((u) => u !== uid);
    const remainingAmount = total - entered;

    const perHead =
      remainingUsers.length > 0
        ? Math.floor(remainingAmount / remainingUsers.length)
        : 0;

    const newSplits = {
      [uid]: entered,
    };

    remainingUsers.forEach((u) => {
      newSplits[u] = perHead;
    });

    setNewItem((prev) => ({
      ...prev,
      newSplits,
    }));
  };

  const toggleUser = (uid) => {
    setNewItem((prev) => {
      const exists = prev.newUsers.includes(uid);

      // REMOVE user
      if (exists) {
        const { [uid]: _, ...restSplits } = prev.newSplits;
        return {
          ...prev,
          newUsers: prev.newUsers.filter((u) => u !== uid),
          newSplits: restSplits,
        };
      }

      // ADD user
      return {
        ...prev,
        newUsers: [...prev.newUsers, uid],
        newSplits: {
          ...prev.newSplits,
          [uid]: 0, // 👈 critical
        },
      };
    });
  };

  const onChange = (e) => {
    const { name, value } = e.target;

    // Special handling when transaction type changes
    if (name === "newType") {
      setNewItem((prev) => {
        let updatedUsers = [...prev.newUsers];
        let updatedSplits = { ...prev.newSplits };

        // If switching to delivery/credit types → REMOVE ME
        if (["instamart", "swiggyfood", "creditcard"].includes(value)) {
          updatedUsers = updatedUsers.filter((u) => u !== myId);
          delete updatedSplits[myId];
        }

        return {
          ...prev,
          newType: value,
          newUsers: updatedUsers,
          newSplits: updatedSplits,
          newDiscount: 0,
        };
      });
      return;
    }

    // Normal change
    setNewItem((prev) => ({ ...prev, [name]: value }));
  };

  const onClickSave = () => {
    // 1️⃣ start from selected users
    let finalUsers = [...newItem.newUsers];

    // 2️⃣ business rule: include me for non-delivery types
    if (!["swiggyfood", "instamart", "creditcard"].includes(newItem.newType)) {
      finalUsers = [...new Set([myId, ...finalUsers])];
    }

    // 3️⃣ build payload
    const payload = {
      users: finalUsers,
      fType: newItem.newType,
      tName: newItem.newType === "instamart" ? "Groceries" : newItem.newName,
      tAmount: Number(newItem.newAmount),
      tDiscount: Number(newItem.newDiscount) || 0,
      tDate: newItem.newDate,
      tNote: newItem.newtNote,
      paidBy: newItem.newPaidBy,
      splitMode: newItem.newSplitMode,
    };

    // 4️⃣ manual split normalization
    if (newItem.newSplitMode === "manual") {
      payload.splits = finalUsers.map((uid) => ({
        user: uid,
        amount: Number(newItem.newSplits[uid] || 0),
      }));
    }

    // 5️⃣ send
    editTransaction(newItem.newId, payload);

    refClose.current.click();

    props.showAlert("Edited Successfully", "success");
  };

  const editBtn = (tx) => {
    ref.current.click();

    const users = tx.users.map((u) => (typeof u === "string" ? u : u._id));

    const splits = {};
    tx.splits.forEach((s) => {
      splits[typeof s.user === "string" ? s.user : s.user._id] = s.amount;
    });

    setNewItem({
      newId: tx._id,
      newDate: tx.tDate?.slice(0, 10),
      newType: tx.fType,
      newName: tx.tName,
      newAmount: tx.tAmount,
      newPaidBy: typeof tx.paidBy === "string" ? tx.paidBy : tx.paidBy._id,
      newtNote: tx.tNote,
      newDiscount: tx.tDiscount ?? 0,
      newUsers: users,
      newSplitMode: tx.splitMode,
      newSplits: splits,
    });
  };

  const onClickEditBtn = () => {
    editBtn(currentTransaction);
  };

  const onClickDelete = async (id) => {
    await deleteTransaction(id);
    props.showAlert("Deleted Successfully", "success");
    await getUserProfile();
    navigate("/moneyflow");
  };

  return (
    <>
      <div className="transDetail-cont p-3">
        <div className="heading-cont d-flex justify-content-between">
          <h2>Transaction Details</h2>
          {myId === currentTransaction?.paidBy._id && (
            <div className="d-flex">
              <button className="actions" onClick={onClickEditBtn}>
                <i class="fa-regular fa-pen-to-square fa-lg"></i>
              </button>
              <button
                className="actions"
                onClick={() => {
                  onClickDelete(currentTransaction._id);
                }}
              >
                <i class="fa-solid fa-trash fa-lg"></i>
              </button>
            </div>
          )}
        </div>

        <div className="cont-1">
          <div className="d-flex align-items-center ">
            <img src={tLogo} className="detail-logo" />
            <div className="detail-head">
              <p className="mb-0">{currentTransaction.tName || "Unnamed"}</p>
              <p className="mb-0 text-muted">
                (
                {currentTransaction.fType === "creditcard"
                  ? "Card/Paid for others"
                  : currentTransaction.fType}
                )
              </p>
            </div>
          </div>
          <hr />
          <h2>Rs.{currentTransaction.fAmount}</h2>
          <div className="d-flex justify-content-between">
            <div className="d-flex  align-items-center gap-2">
              <i class="fa-solid fa-user fa-md"></i>
              <p className="mb-0">
                paid by <span>{currentTransaction.paidBy.name}</span>
              </p>
            </div>
            <div>
              <p className="mb-0">
                {formatToIST(currentTransaction.tDate).slice(0, 11)}
              </p>
            </div>
          </div>
          <hr />
          <div className="d-flex justify-content-between">
            <p className="text-muted small-text">
              Created at: <br /> Last Updated at:
            </p>
            <p className="text-muted small-text">
              {formatToIST(currentTransaction.createdAt)} <br />{" "}
              {formatToIST(currentTransaction.updatedAt)}
            </p>
          </div>
        </div>

        <div className="cont-1 mt-3 breaknote-cont">
          <div className="m-3">
            <h3>BreakDown</h3>
            <div className="breakdown">
              <div className="d-flex justify-content-between">
                <p>Amount</p>
                <p>{currentTransaction.tAmount}</p>
              </div>

              <div className="d-flex justify-content-between">
                <p>Discount</p>
                <p>{currentTransaction.tDiscount}</p>
              </div>

              {(currentTransaction.fType === "swiggyfood" ||
                currentTransaction.fType === "instamart") && (
                <div className="d-flex justify-content-between">
                  <p>Commission</p>
                  <p>{currentTransaction.tCommission}</p>
                </div>
              )}

              <hr />
              <div className="d-flex justify-content-between">
                <p>Final Amount</p>
                <p>{currentTransaction.fAmount}</p>
              </div>
            </div>
          </div>
          <div
            className={
              currentTransaction.tNote.length > 0 ? "m-3 d-block" : "d-none m-3"
            }
          >
            <h3>Note</h3>
            <div className="note">
              <p>{currentTransaction.tNote}</p>
            </div>
          </div>
        </div>

        <div className="cont-1 mt-3">
          <h3>
            {currentTransaction.splits.length > 1
              ? "Transaction Between"
              : "Transaction With"}
          </h3>

          <div>
            {currentTransaction.splits.map((u) => (
              <div className="d-flex  align-items-center gap-2 m-2">
                <i class="fa-solid fa-user fa-md"></i>
                <p className="mb-0">{u.user.name}</p>
                <p className="mb-0">Rs.{u.amount}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <button
        type="button"
        className="btn btn-primary d-none"
        data-bs-toggle="modal"
        ref={ref}
        data-bs-target="#exampleModal"
      >
        Launch modal
      </button>

      <div className="modal fade" id="exampleModal" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Transaction</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              {/* Users */}
              <div className="mb-3">
                <label className="form-label">Users</label>
                {users.map((u) => (
                  <div key={u._id} className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={newItem.newUsers.includes(u._id)}
                      onChange={() => toggleUser(u._id)}
                    />
                    <label className="form-check-label">
                      {u.name || u.email}
                    </label>
                  </div>
                ))}
              </div>

              {/* Paid By */}
              <div className="mb-3">
                <label className="form-label">Paid By</label>
                <select
                  className="form-select"
                  name="newPaidBy"
                  value={newItem.newPaidBy}
                  onChange={onChange}
                >
                  <option value="">Select</option>
                  <option value={myId}>You</option>
                  {users
                    .filter((u) => newItem.newUsers.includes(u._id))
                    .map((u) => (
                      <option key={u._id} value={u._id}>
                        {u.name || u.email}
                      </option>
                    ))}
                </select>
              </div>

              {/* Type */}
              <div className="mb-3">
                <label className="form-label">Type</label>
                <select
                  className="form-select"
                  name="newType"
                  value={newItem.newType}
                  onChange={onChange}
                >
                  <option value="">Select</option>
                  <option value="restaurant">Restaurant</option>
                  {userDetails.role === "ADMIN" && (
                    <option value="instamart">Instamart</option>
                  )}
                  {userDetails.role === "ADMIN" && (
                    <option value="swiggyfood">Swiggy Food</option>
                  )}
                  <option value="creditcard">Card/Paid for Others</option>
                  <option value="others">Miscellaneous</option>
                </select>
              </div>

              {/* Amount */}
              <div className="mb-3">
                <label className="form-label">Amount</label>
                <input
                  type="number"
                  className="form-control"
                  name="newAmount"
                  value={newItem.newAmount}
                  onChange={onChange}
                />
              </div>

              {/* Date */}
              <div className="mb-3">
                <label className="form-label">Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="newDate"
                  value={newItem.newDate}
                  onChange={onChange}
                />
              </div>

              {/* Name */}
              <label className="form-label">Name</label>
              <input
                type="text"
                className="form-control"
                name="newName"
                value={
                  newItem.newType === "instamart"
                    ? "Groceries"
                    : newItem.newName
                }
                disabled={newItem.newType === "instamart"}
                onChange={onChange}
              />

              {/* Split Mode */}
              <div className="mb-3 mt-3">
                <label className="form-label">Split Mode</label>
                <select
                  className="form-select"
                  name="newSplitMode"
                  value={newItem.newSplitMode}
                  onChange={onChange}
                >
                  <option value="equal">Equally</option>
                  <option value="manual">Manually</option>
                </select>
              </div>

              {/* Manual Split */}
              {newItem.newSplitMode === "manual" &&
                Object.keys(newItem.newSplits).map((uid) => {
                  const user =
                    uid === myId
                      ? { _id: myId, name: "You" }
                      : users.find((u) => u._id === uid);

                  return (
                    <div key={uid} className="d-flex align-items-center mb-2">
                      <label className="me-2" style={{ width: "100px" }}>
                        {user?.name}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={newItem.newSplits[uid]}
                        onChange={(e) =>
                          onManualSplitChange(uid, e.target.value)
                        }
                      />
                    </div>
                  );
                })}

              <div className="mb-3">
                <label className="form-label">Note</label>
                <input
                  type="text"
                  className="form-control"
                  name="newtNote"
                  value={newItem.newtNote}
                  onChange={onChange}
                />
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                ref={refClose}
              >
                Close
              </button>
              <button className="btn btn-primary" onClick={onClickSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionDetail;
